import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=2512eddc&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=js&"
export * from "./PasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=2512eddc&lang=scss&scoped=true&"
import style1 from "./PasswordReset.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512eddc",
  null
  
)

export default component.exports